export const get_money_transfers = `query get_money_transfers($paginator: Paginator!, $order: ListingOrder!, $filter: ListingFilter!){
    get_money_transfers(paginator: $paginator, order: $order, filter: $filter){
        money_transfers{
            transaction_code
            status
            from_account
            currency{
                currency
                name
                decimal
            }
            amount
            order_date
        }
        page
        page_count
    }
}`;
